'use strict';

var KayleeCalendar = require('./KayleeCalendar');
var KayleeCall = require('./KayleeCall');
var KayleeCallParticipants = require('./KayleeCallParticipants');
var KayleeCalls = require('./KayleeCalls');
var KayleeCompanies = require('./KayleeCompanies');
var KayleeCompany = require('./KayleeCompany');
var KayleeController = require('./KayleeController');
var KayleeControllers = require('./KayleeControllers');
var KayleeDirectory = require('./KayleeDirectory');
var KayleeDirectories = require('./KayleeDirectories');
var KayleeEquipment = require('./KayleeEquipment');
var KayleeEquipments = require('./KayleeEquipments');
var KayleeEquipmentStates = require('./KayleeEquipmentStates');
var KayleeEquipmentStorage = require('./KayleeEquipmentStorage');
var KayleeEquipmentTypes = require('./KayleeEquipmentTypes');
var KayleeEvent = require('./KayleeEvent');
var KayleeEvents = require('./KayleeEvents');
var KayleeInaraInfo = require('./KayleeInaraInfo');
var KayleeKayleeInfo = require('./KayleeKayleeInfo');
var KayleeLog = require('./KayleeLog');
var KayleeLogs = require('./KayleeLogs');
var KayleeLogMessages = require('./KayleeLogMessages');
var KayleeRemoteControlSessions = require('./KayleeRemoteControlSessions');
var KayleeRoomControlCommands = require('./KayleeRoomControlCommands');
var KayleeRoom = require('./KayleeRoom');
var KayleeRoomConfig = require('./KayleeRoomConfig');
var KayleeRoomConfigValidated = require('./KayleeRoomConfigValidated');
var KayleeRooms = require('./KayleeRooms');
var KayleeSite = require('./KayleeSite');
var KayleeSites = require('./KayleeSites');
var KayleeTosHtml = require('./KayleeTosHtml');
var KayleeTosInfo = require('./KayleeTosInfo');
var KayleeTutorials = require('./KayleeTutorials');
var KayleeUser = require('./KayleeUser');
var KayleeUserMessages = require('./KayleeUserMessages');
var KayleeUsers = require('./KayleeUsers');
var KayleeVisualTheme = require('./KayleeVisualTheme');
var KayleeVisualThemes = require('./KayleeVisualThemes');

var log = require('../log/Log').channel('KayleeSerializer');

var KayleeSerializer = {
    fromJson: fromJson,
    toJson: toJson,
};

var nodeFactories = [
    {
        calendar: KayleeCalendar,
        call: KayleeCall,
        callParticipants: KayleeCallParticipants,
        company: KayleeCompany,
        controller: KayleeController,
        directory: KayleeDirectory,
        equipment: KayleeEquipment,
        equipmentStates: KayleeEquipmentStates,
        equipmentStorage: KayleeEquipmentStorage,
        equipmentTypes: KayleeEquipmentTypes,
        event: KayleeEvent,
        inaraInfo: KayleeInaraInfo,
        kayleeInfo: KayleeKayleeInfo,
        log: KayleeLog,
        logMessages: KayleeLogMessages,
        room: KayleeRoom,
        roomConfig: KayleeRoomConfig,
        roomConfigValidated: KayleeRoomConfigValidated,
        roomControlCommands: KayleeRoomControlCommands,
        remoteControlSessions: KayleeRemoteControlSessions,
        site: KayleeSite,
        tosHtml: KayleeTosHtml,
        tosInfo: KayleeTosInfo,
        tutorials: KayleeTutorials,
        user: KayleeUser,
        userMessages: KayleeUserMessages,
        visualTheme: KayleeVisualTheme,
    }, {
        calls: KayleeCalls, // requires call and room
        companies: KayleeCompanies, // requires company
        controllers: KayleeControllers, // requires controller and room
        directories: KayleeDirectories, // requires directory
        equipments: KayleeEquipments, // requires equipment and room
        logs: KayleeLogs, // requires controller and log
        rooms: KayleeRooms, // requires site and user
        sites: KayleeSites, // requires company and user
        users: KayleeUsers, // requires company, site, or room
        visualThemes: KayleeVisualThemes, // requires visualTheme
    }, {
        events: KayleeEvents, // could require anything
    },
];

function fromJson(data) {
    var key;
    var handledKeys = [];

    for (var i = 0; i < nodeFactories.length; i++) {
        for (key in data) {
            if (!data.hasOwnProperty(key)) continue;

            var item = data[key];

            if (!item.hasOwnProperty('$nodeType')) {
                log.error('fromJson: no $nodeType property for ' + key);
                continue;
            }

            if (nodeFactories[i].hasOwnProperty(item.$nodeType)) {
                nodeFactories[i][item.$nodeType].fromJson(item);
                handledKeys.push(key);
            }
        }
    }

    for (key in data) {
        if (!data.hasOwnProperty(key)) continue;
        if (!handledKeys.includes(key)) {
            log.error('fromJson: unhandled $nodeType ' + data[key].$nodeType + ' for ' + key);
        }
    }
}

function toJson(obj) {
    var data = {};

    for (var key in obj) {
        if (!obj.hasOwnProperty(key)) continue;

        var item = obj[key];

        if (typeof item.$toJson !== 'function') {
            log.error('toJson: no $toJson method for ' + key);
            continue;
        }

        data[key] = item.$toJson();
    }

    return data;
}

module.exports = KayleeSerializer;
